import type { Node as ProseMirrorNode } from '@tiptap/pm/model';

import { TiptapNodeType } from '../../tiptapTypes';

export type TaskListFeatureSuggestionState = {
    hasTitle: boolean;
    /** Tasks in the document's root task list, excluding nested sub-tasks. */
    topLevelTaskCount: number;
    /** Completed tasks at any depth, matching the legacy suggestion's descendant count. */
    completedTaskCount: number;
};

/**
 * Summarises the parts of a task list document the feature suggestions trigger off.
 *
 * Read from the live editor document rather than the element's persisted content, which
 * lags behind by the content save debounce.
 */
export const getTaskListFeatureSuggestionState = (doc: ProseMirrorNode): TaskListFeatureSuggestionState => {
    const taskList = doc.lastChild;

    let completedTaskCount = 0;

    // Only the task list structure is descended into - this runs on every document change, so
    // there's no need to walk the text content of every task.
    doc.descendants((node) => {
        const nodeType = node.type.name;

        if (nodeType === TiptapNodeType.taskItem && node.attrs.checked) completedTaskCount += 1;

        return nodeType === TiptapNodeType.taskList || nodeType === TiptapNodeType.taskItem;
    });

    return {
        hasTitle: doc.firstChild?.type.name === TiptapNodeType.taskListTitle,
        topLevelTaskCount: taskList?.type.name === TiptapNodeType.taskList ? taskList.childCount : 0,
        completedTaskCount,
    };
};
